module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appLoadingWrapper d-flex flex-column justify-content-center h-100 w-100"
  }, [_c('div', {
    staticClass: "w-100 text-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/logo.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('loader')], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-264e6a20", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-264e6a20"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Loading.vue
// module id = 2475
// module chunks = 0